"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var analytics_sidecar_1 = require("../../../engine/analytics-sidecar");
var settings_sidecar_1 = require("../../../engine/settings-sidecar");
var common_sidecar_1 = require("../../../main/common-sidecar");
var _registerPipelines_sidecar_1 = require("../../../pipeline/_registerPipelines-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var clickEater_sidecar_1 = require("../../../uiParts/clickEater-sidecar");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueLayers_sidecar_1 = require("./rogueLayers-sidecar");
var rogueTester_7drl_2023_sidecar_1 = require("./rogueTester_7drl_2023-sidecar");
require("./rogueTester_rogue-sidecar");
function create() {
    //  let game = common.getPhaserScene().game
    // Init analytics
    var gameKey = 'f5485694c2cbb454a5a7e83005306ea5';
    var gameSecretKey = '253fcbecd7f1a20c80cf31f759ef2edbe97dd966';
    var build = 'browser 0.5.0';
    analytics_sidecar_1.analytics.init(build, gameKey, gameSecretKey);
    // underPerf.recordCreate('game')
    spritesUtil_sidecar_1.spritesUtil.setDefaultScale(2);
    settings_sidecar_1.settings.create('rogue:settings', 1);
    // goatSettings.create()
    rogueLayers_sidecar_1.rogueLayers.create();
    // _registerPipelines.registerAll()
    // rogueScene_registerData.registerData()
    // cardKeyboard.create()
    rogueInput_sidecar_1.rogueInput.create();
    //goatKeyboard.create()
    // buttons2.setDefaultFrames(buttons2.defaultFramesBasic)
    // buttons2.setDefaultFont(echoFonts.getData().font6)
    var soundsJson = common_sidecar_1.common.getPhaserScene().cache.json.get('audioSprite2');
    // goatSounds.load(soundsJson, '/assets/music')
    _registerPipelines_sidecar_1._registerPipelines.assign();
    // uiFps.create(rogueLayers.getLayers().ui)
    // uiFps.setOpen(true)
    clickEater_sidecar_1.clickEater.create();
    // underKeyboard.create()
    // goatSpaceBackground.create()
    // goatTest.create()
    // physics.create()
    // physicsCollisions.installAll(physics.get())
    // goatSaver.load()
    // cardTester.createCardTestScene()
    // rogueTester_rogue.createRogueTestScene()
    rogueTester_7drl_2023_sidecar_1.rogueTester_7drl_2023.createRogueTestScene();
    var context = {};
    return context;
}
exports.create = create;
